

















import { Component, Mixins } from "vue-property-decorator";
import { NumberInput, ModelEditableMixin } from "../../../../../base/components/system";
import { Bookmark } from "../../../../domain/format/objects";

@Component({
  components: {
    NumberInput,
  },
})

export default class BookmarkEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: Bookmark) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: Bookmark) => T, defaultValue: T) => T;

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get name(): string {
    return this.readPropertyOrDefault(s => s.value, undefined);
  }

  set name(value: string) {
    this.writePropertyWhenValid(s => s.value = value);
  }

  get row(): number {
    return this.readPropertyOrDefault(s => s.row, undefined);
  }
  
  set row(value: number) {
    this.writePropertyWhenValid(s => s.row = value);
  }

  get column(): number {
    return this.readPropertyOrDefault(s => s.column, undefined);
  }

  set column(value: number) {
    this.writePropertyWhenValid(s => s.column = value);
  }

  get isStepEnable(): boolean {
    return true;
  }

  correct(value: number): number {
    return Math.floor(value);
  }

  isValid(value: number): boolean {
    return (0 < value) && (value < 11);
  }
}
